import {UpdateQueryOptions} from "../../../../common/state/query.actions";

// export class UpdateInvoiceChargesQuery {
//   static readonly type = '[INVOICE_CHARGES] Update Query';
//
//   constructor(public options?: UpdateQueryOptions) {
//   }
// }

export class UpdateInventoryRelatedCircuitActiveSiderSection {
  static readonly type = '[INVENTORY_RELATED_CIRCUIT] Update active sider section';
  constructor(public name: string) {}
}
